module.exports = "<ngx-dynamic-component [moduleData]=\"item.moduleData\"\n                       [parameters]=\"item.parameters\">\n</ngx-dynamic-component>\n"